import { lazy } from 'react';
import { RoutePath } from 'src/enums/routePath';
import MainLayout from 'src/layouts/MainLayout';
import { RouteI } from 'src/models/router';

const LoginPage = import('../pages/Login');
const MediaPage = import('../pages/Media');
const TilePage = import('../pages/Tile');
const SettingsPage = import('../pages/Settings');
const ColorPage = import('../pages/Color');

export const routes: RouteI[] = [
  {
    path: RoutePath.LOGIN,
    Component: lazy(() => LoginPage)
  },
  {
    path: RoutePath.TILE,
    Component: lazy(() => TilePage),
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: RoutePath.SETTINGS,
    Component: lazy(() => SettingsPage),
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: RoutePath.MEDIA,
    Component: lazy(() => MediaPage),
    Layout: <MainLayout />,
    isPrivate: true
  },
  {
    path: RoutePath.COLOR,
    Component: lazy(() => ColorPage),
    Layout: <MainLayout />,
    isPrivate: true
  }
];
